import React from "react";
import {Tag} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {HealthCheckStatus} from "../../../../models/health-checker/health-checker";
import {useTranslate} from "../../../../hooks/translate.hook";

interface DashboardCheckStatusProps {
    status: HealthCheckStatus;
}

export const DashboardCheckStatus: React.FC<DashboardCheckStatusProps> = ({status}) => {
    const t = useTranslate();
    const isOk = status === "ok";

    return (
        <Tag
            className="health-center-dashboard__status"
            color={isOk ? "success" : "error"}
            icon={
                <FontAwesomeIcon
                    icon={["fas", isOk ? "check-circle" : "exclamation-triangle"]}
                />
            }
        >
            {isOk
                ? t("HEALTH-CENTER.DASHBOARD.STATUS.OK", {defaultValue: "OK"})
                : t("HEALTH-CENTER.DASHBOARD.STATUS.NOT-OK", {defaultValue: "Not OK"})}
        </Tag>
    );
};
